export function suggestedLocations(locations: Array<string>) {
  return ['suggestedLocations', locations] as const
}
